<template>
    <div class="loading-icon">
        <h5 class="m-b-16">Loading Icon</h5>
        <div class="loading-icon__type m-b-24">
            <strong>Icon type</strong>
            <div class="icons__wapper slider m-t-10">
                <div class="slide-one m-b-8">
                    <template v-for="index in 6">
                        <template v-if="icons[index-1]">
                            <div :key="index"
                                :class="['icon__wapper scaled', !([3, 6].includes(index)) ? 'm-r-16' : '', index > 3 ? 'm-t-14': '', icons[index-1].key == currentIcon.key ? 'active' : '']"
                                @click="changeIcon(icons[index-1].key)">
                                <div v-if="icons[index-1].src == undefined || icons[index-1].src == null"
                                    :class="[icons[index-1].class]"
                                    v-html="icons[index-1].code">
                                </div>
                                <div v-else>
                                    <img :class="icons[index-1].key" :src="getImgUrl(icons[index-1].src)" alt="">
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="slide-two d-none m-b-6">
                    <template v-for="index in 6">
                        <template v-if="icons[index+5]">
                            <div :key="index"
                                :class="['icon__wapper scaled', !([3, 6].includes(index)) ? 'm-r-16' : '', index > 3 ? 'm-t-16': '', icons[index+5].key == currentIcon.key ? 'active' : '']"
                                @click="changeIcon(icons[index+5].key)">
                                <div v-if="icons[index+5].src == undefined || icons[index+5].src == null"
                                    :class="[icons[index+5].class]"
                                    v-html="icons[index+5].code"
                                ></div>
                                    <div v-else>
                                    <img :class="icons[index+5].key" :src="getImgUrl(icons[index+5].src)" alt="">
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="slider__dots">
                    <a @click="onSlide" class="slider__dot dot-active" data-pos="0"></a>
                    <a @click="onSlide" class="slider__dot" data-pos="1"></a>
                </div>
            </div>
        </div>
        <div :class="['loading-icon__background m-b-24', iconsExcludeColor.includes(currentIcon.key) ? 'field-disabled' : '']">
            <strong>Color</strong>
            <VueColorpicker v-model="formLoadingIcon.background"/>
        </div>
        <div class="loading-icon__size">
            <strong>Size</strong>
            <a-select :prefixCls="$prefixClass.select" v-model="formLoadingIcon.size">
                <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                <a-select-option v-for="size in sizes" :key="size.key" :value="size.key">{{size.title}}</a-select-option>
            </a-select>
        </div>
    </div>
</template>
<script>
import { icons as loadingIcons } from './../constant'
export default {
    name: "LoadingIcon",
    props: {
        value: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            icons: loadingIcons,
            iconsExcludeColor: ['cat-spinner', 'dog-spinner', 'lds-dots', 'lds-preloader', 'lds-gegga'],
            sizes: [
                {
                    key: 'very-small',
                    title: 'Very small'
                },
                {
                    key: 'small',
                    title: 'Small'
                },
                {
                    key: 'medium',
                    title: 'Medium'
                },
                {
                    key: 'large',
                    title: 'Large'
                }
            ]
        }
    },
    computed: {
        formLoadingIcon: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            }
        },
        currentIcon() {
            return this.icons.find(icon => this.formLoadingIcon.icon == icon.key)
        }
    },
    watch: {
    },
    created() {},
    methods: {
        submitForm() {
        },
        changeIcon(key) {
            this.formLoadingIcon.icon = key
        }
    }
};
</script>

<style lang="scss">
    .loading-icon {
        label {
            margin-bottom: 0;
        }
        &__type {
            .icon {
                &__wapper {
                    width: 86px;
                    height: 86px;
                    border-radius: 4px;
                    border: solid 1px $line-color;
                    display: inline-block;
                    cursor: pointer;
                    margin: 0;
                    padding: 0;
                    > div:first-child {
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                    }
                    &.scaled {
                        > div:first-child {
                            transform: scale(0.6);
                            // display: flex;
                            .cat-spinner, .dog-spinner {
                                width: 86px;
                                height: 86px;
                                vertical-align: unset;
                            }
                            .preloader__loading {
                                margin-left: -8px;
                                margin-top: -8px;
                            }
                            .lds-dots {
                                margin-top: 50%
                            }
                        }
                    }
                    &.active {
                        border-color: $success-color;
                        &::before {
                            content: "\F058";
                            font-family: Font Awesome\ 5 Pro;
                            font-weight: 900;
                            position: absolute;
                            margin-top: -10px;
                            color: $success-color;
                            margin-left: 75px;
                        }
                    }
                }
            }
        }
        &__background, &__size {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

</style>
